import { Component } from '@theme/component';

/**
 * Displays volume pricing table with expandable rows.
 * Shows pricing tiers based on quantity thresholds.
 *
 * @extends {Component}
 */
class VolumePricingComponent extends Component {
  /**
   * Toggles the expanded state of the volume pricing table.
   * Also toggles aria-expanded on the trigger button so assistive
   * technologies can announce the collapsed / expanded state
   * (WCAG 4.1.2 Name, Role, Value).
   */
  toggleExpanded() {
    const isExpanded = this.classList.toggle('volume-pricing--expanded');
    const toggle = this.refs?.volumePricingToggle;
    if (toggle) {
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }
  }
}

if (!customElements.get('volume-pricing')) {
  customElements.define('volume-pricing', VolumePricingComponent);
}
